export default __webpack_public_path__ + "static/media/closet5-before1-480w.08ee01ba.webp";